<div
  class="upload-file-area"
  [class.is-dragging]="isDragging"
  (click)="fileInput.click()"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
>
  <input #fileInput type="file" [accept]="accept()" (change)="onFileChange($event)" hidden />
  <ptl-icon [icon]="LucideUpload" size="m"></ptl-icon>
  <span class="upload-file-area__link">{{ linkText() ?? ('translations.fileDropzone.clickToUpload' | transloco) }}</span>
  @if (hintText()) {
    <span class="upload-file-area__hint">{{ hintText() }}</span>
  }
</div>
